import * as i0 from "@angular/core";
var Globals = /** @class */ (function () {
    function Globals() {
    }
    Globals.ngInjectableDef = i0.defineInjectable({ factory: function Globals_Factory() { return new Globals(); }, token: Globals, providedIn: "root" });
    return Globals;
}());
export { Globals };
